import { classNames } from 'assets/utils/helper';
import React from 'react';

type ToggleProps = {
  filter?: string;
  label?: string;
  labelFor?: string;
  checked?: boolean;
  extraClass?: string;
  onChange: Function;
  disabled?: boolean;
};

const Toggle = (props: ToggleProps) => {
  const { filter, label, labelFor, checked, onChange, extraClass, disabled } =
    props;

  const switchToggle = checked ? 'toggle' : '';
  const active = checked ? 'active' : '';

  return (
    <div
      className={classNames(
        'toggle-filter',
        extraClass ? extraClass : '',
        disabled ? 'disabled' : ''
      )}
      onClick={() => !disabled && onChange(!checked)}
      onKeyDown={e => !disabled && e.key === 'Enter' && onChange(!checked)}
      tabIndex={0}
      role="checkbox"
      aria-checked={checked}
    >
      {label && (
        <label htmlFor={filter || labelFor} className="osf-body-copy">
          {label}
        </label>
      )}
      <div id="toggle-switch" className={`toggle-switch ${active}`}>
        <input
          className={`toggle-circle`}
          type="checkbox"
          checked={checked}
          id={filter || labelFor}
          name={filter || labelFor}
          tabIndex={-1}
          onClick={e => e.stopPropagation()}
          disabled={disabled}
        ></input>
        <span className={`toggle-btn ${switchToggle}`}></span>
      </div>
    </div>
  );
};

export default Toggle;
